import { Link } from "react-router-dom";
import { getContentByLocale } from "../content";
import { useI18n } from "../i18n";
import { PageSeo } from "../components/seo/PageSeo";

export function NotFoundPage() {
  const { locale } = useI18n();
  const content = getContentByLocale(locale);
  const notFoundLabel = locale === "pt" ? "Página não encontrada." : "Page not found.";

  return (
    <>
      <PageSeo title={`404 | ${content.seo.defaultTitle}`} description={content.seo.defaultDescription} />
      <section className="section info-panel">
        <h1>404</h1>
        <p className="info-copy">{notFoundLabel}</p>
        <Link className="hero-cta" to="/">
          {content.nav[0]?.label ?? "Home"}
        </Link>
      </section>
    </>
  );
}
